import React, {Fragment} from "react";

export default function Nl2Br(props) {
    let elements = typeof props.value === 'string' ? props.value.split('\n') : [];
    return elements.map((value, index) => {
        return <Fragment key={index}>{value}{(index + 1) !== elements.length && <br/>}</Fragment>
    })
}